import React, { useEffect, useState } from 'react'
import { openURL } from 'renderer/viewer/lib/simpleUtils'
import utopiaLogo from '../../../assets/utopia-logo.png'
import { UTOPIA_DISCORD_URL } from '../../utopia/constants'
import UtopiaNavAuthDropdown from './UtopiaNavAuthDropdown'
import styles from './utopiaLanding.module.css'

export type UtopiaPageId = 'home' | 'stats' | 'join'

const NAV_ITEMS: Array<{ id: UtopiaPageId; label: string }> = [
  { id: 'home', label: 'Accueil' },
  { id: 'stats', label: 'Stats' },
  { id: 'join', label: 'Nous rejoindre' },
]

type Props = {
  activePage: UtopiaPageId
  onPageChange: (page: UtopiaPageId) => void
  onOptionsClick?: () => void
  onPlayClick?: () => void
}

export default function UtopiaNav ({ activePage, onPageChange, onOptionsClick, onPlayClick }: Props) {
  const [menuOpen, setMenuOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 720px)')
    const update = () => setIsMobile(mq.matches)
    update()
    mq.addEventListener('change', update)
    return () => mq.removeEventListener('change', update)
  }, [])

  useEffect(() => {
    if (!isMobile) setMenuOpen(false)
  }, [isMobile])

  const selectPage = (page: UtopiaPageId) => {
    onPageChange(page)
    setMenuOpen(false)
  }

  return (
    <header className={styles.nav}>
      <div className={styles.navLeft}>
        <div className={styles.logoWrap}>
          <img
            src={utopiaLogo}
            alt="Utopie"
            className={styles.logo}
            width={120}
            height={80}
            fetchPriority="high"
            loading="eager"
            decoding="sync"
          />
        </div>
        {isMobile && (
          <button
            type="button"
            className={styles.navMenuToggle}
            aria-expanded={menuOpen}
            aria-label="Menu navigation"
            onClick={() => setMenuOpen(o => !o)}
          >
            ☰
          </button>
        )}
        <div className={`${styles.navLinks} ${menuOpen ? styles.navLinksOpen : ''}`}>
          {NAV_ITEMS.map(({ id, label }) => (
            <button
              key={id}
              type="button"
              className={`${styles.navLink} ${activePage === id ? styles.navLinkActive : ''}`}
              onClick={() => selectPage(id)}
            >
              {label}
            </button>
          ))}
          <button
            type="button"
            className={`${styles.navLink} ${styles.navLinkDiscord}`}
            onClick={() => {
              openURL(UTOPIA_DISCORD_URL, true)
              setMenuOpen(false)
            }}
          >
            Discord
          </button>
        </div>
      </div>
      <div className={styles.navAuth}>
        <UtopiaNavAuthDropdown onOptionsClick={onOptionsClick} onPlayClick={onPlayClick} />
      </div>
    </header>
  )
}
